import React, { useState } from 'react';
import styles from './index.modules.less';
import MarqueeText from '../../../../../../components/MarqueeText';
import { Icon } from 'antd-mobile';
export default function BuyAgainBar({ text, onClick }) {
  const [visible, setVisible] = useState(true);
  return visible ? (
    <div className={styles.container}>
      <div className={styles.content} onClick={onClick}>
        <MarqueeText text={text}></MarqueeText>
      </div>
      <Icon type="cross" size="sm" onClick={() => setVisible(false)} style={{ flexShrink: 0 }} />
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/BuyAgainBar/index.js